import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import Select from '../../../components/forms/Select'
import MultiContributorsAutocomplete
    from '../../../referencial/components/contributor/components/MultiContributorsAutocomplete'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import QualityAction from 'quality/actions/QualityAction'
import FractionAction from 'referencial/components/fraction/actions/FractionAction'
import SupportAction from 'referencial/components/support/actions/SupportAction'
import { Grid } from '@mui/material'

const ImportQualityDefaultValue = ({
    defaultValue = {},
    isEditMode = false,
    hydrobio = false,
    onChange = () => { },
}) => {
    const dispatch = useDispatch()
    const {
        contributors,
        qualifications,
        status,
        fractions,
        supports,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
        qualifications: store.QualityReducer.qualifications,
        status: store.QualityReducer.status,
        fractions: store.FractionReducer.fractions,
        supports: store.SupportReducer.supports,
    }), shallowEqual)

    useEffect(() => {
        if (contributors.length === 0) {
            dispatch(ContributorAction.fetchContributors())
        }
        if (qualifications.length === 0) {
            dispatch(QualityAction.fetchQualifications())
        }
        if (status.length === 0) {
            dispatch(QualityAction.fetchStatus())
        }
        if (fractions.length === 0) {
            dispatch(FractionAction.fetchFractions())
        }
        if (supports.length === 0) {
            dispatch(SupportAction.fetchSupports())
        }
    }, [dispatch])

    return (
        <fieldset>
            <legend>{i18n.defaultValue}</legend>
            <>
                <Grid container spacing={1}>
                    {/*      <Input
                    col={3}
                    title={i18n.stationCodePrefix}
                    value={defaultValue.stationCodePrefix}
                    onChange={(id) => onChange({ stationCodePrefix: id })}
                    disabled={!isEditMode}
                /> */}
                    <Grid size={3}>
                        <MultiContributorsAutocomplete
                            options={contributors}
                            label={i18n.sampler}
                            onChange={(id) => onChange({ sampler: id })}
                            values={defaultValue.sampler}
                            disabled={!isEditMode}
                            data-cy='defaultImportSampler'
                        />
                    </Grid>
                    <Grid size={3}>
                        <MultiContributorsAutocomplete
                            options={contributors}
                            label={i18n.producer}
                            onChange={(id) => onChange({ producer: id }) }
                            values={defaultValue.producer}
                            disabled={!isEditMode}
                            data-cy='defaultImportProducer'
                        />
                    </Grid>
                    {!hydrobio && (
                        <Grid size={3}>
                            <MultiContributorsAutocomplete
                                options={contributors}
                                label={i18n.laboratory}
                                onChange={(id) => onChange({ labo: id }) }
                                values={defaultValue.labo}
                                disabled={!isEditMode}
                                data-cy='defaultImportLaboratory'
                            />
                        </Grid>
                    )}
                    {hydrobio && (
                        <Grid size={3}>
                            <MultiContributorsAutocomplete
                                options={contributors}
                                label={i18n.determiner}
                                onChange={(id) => onChange({ determiner: id }) }
                                values={defaultValue.determiner}
                                disabled={!isEditMode}
                                data-cy='defaultImportDeterminer'
                            />
                        </Grid>
                    )}
                </Grid>
                <Grid container spacing={1}>
                    <Grid size={3}>
                        <Select
                            label={i18n.support}
                            options={supports}
                            value={defaultValue.support}
                            onChange={(code) => onChange({ support: parseInt(code) || undefined })}
                            clearFunction
                            displayWithCode
                            active={isEditMode}
                            disabled={!isEditMode}
                            data-cy='defaultImportSupport'
                        />
                    </Grid>
                    {!hydrobio && (
                        <Grid size={3}>
                            <Select
                                label={i18n.fractions}
                                options={fractions}
                                value={defaultValue.fraction}
                                onChange={(code) => onChange({ fraction: code })}
                                clearFunction
                                displayWithCode
                                active={isEditMode}
                                disabled={!isEditMode}
                                data-cy='defaultImportFraction'
                            />
                        </Grid>
                    )}
                    <Grid size={3}>
                        <Select
                            label={i18n.status}
                            options={status}
                            value={defaultValue.status}
                            onChange={(v) => onChange({ status: v })}
                            nullLabel='&nbsp;'
                            active={isEditMode}
                            disabled={!isEditMode}
                            data-cy='defaultImportStatus'
                        />
                    </Grid>
                    <Grid size={3}>
                        <Select
                            label={i18n.qualification}
                            options={qualifications}
                            value={defaultValue.qualification}
                            onChange={(v) => onChange({ qualification: v })}
                            nullLabel='&nbsp;'
                            active={isEditMode}
                            disabled={!isEditMode}
                            data-cy='defaultImportQualification'
                        />
                    </Grid>
                </Grid>
            </>
        </fieldset>
    )
}

ImportQualityDefaultValue.propTypes = {
    defaultValue: PropTypes.shape({
        sampler: PropTypes.number,
        producer: PropTypes.number,
        labo: PropTypes.number,
        determiner: PropTypes.number,
        support: PropTypes.number,
        fraction: PropTypes.number,
        status: PropTypes.number,
        qualification: PropTypes.number,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    hydrobio: PropTypes.bool,
}

export default ImportQualityDefaultValue